export default "https://cdn-static.gokick.com/assets/9903fb7c557cf9d7d858f1d02aec0837d292f7c0/images/two-pack.1e6632cffb735562eaf44e7ebc36435e.png";